import moreAboutMeReducer from './store/Reducer'
import MoreAboutMeService from './Service'
import React, { useReducer, useEffect } from 'react'
import { get, pick } from 'lodash'
import { setResponses } from './store/Actions'
import { moreAboutMeInitialState } from './store/State'
import { IResponseUpdateRequestPayload, IResponsesUpdateRequestPayload } from 'types'
import UserResponsesManagerService from 'smart-components/user-responses-manager/Service'
import { IProps } from './Interface'
import { useServiceState, useNotification } from 'helpers'

const moreAboutMeContext = {
  state: moreAboutMeInitialState,
  handlers: {
    handleUpdateResponses: () => {},
    handleChangeResponse: (_payload: IResponseUpdateRequestPayload) => {}
  }
}

export type MoreAboutMeContext = typeof moreAboutMeContext

export const MoreAboutMeContextProvider = React.createContext<MoreAboutMeContext>(moreAboutMeContext)

const Provider: React.FC<IProps> = ({ children, responses }) => {
  const [state, dispatch] = useReducer(moreAboutMeReducer, moreAboutMeInitialState)
  const userResponsesManagerState = useServiceState(UserResponsesManagerService, false)
  const { emitError } = useNotification()

  responses = responses || get(userResponsesManagerState, 'userResponses.responses', {})

  const updateResponses = async (payload: IResponsesUpdateRequestPayload) => {
    const error = await UserResponsesManagerService.updateResponses(payload)
    if (error) {
      emitError(error)
    }
  }

  const moreAboutMeResponses = pick(responses, [
    'impactOn',
    'impactGoodAt',
    'impactInterested',
    'mostProductiveInspired',
    'whenHaveYouFailed',
    'toGetMeTalking',
    'inDealingWithPeople'
  ])

  useEffect(() => {
    dispatch(setResponses(moreAboutMeResponses))
  }, [responses])

  const handlers = {
    handleUpdateResponses: MoreAboutMeService.handleUpdateResponses(moreAboutMeResponses, state, updateResponses),
    handleChangeResponse: MoreAboutMeService.handleChangeResponse(dispatch)
  }

  const contextValue = {
    state,
    handlers
  }

  return <MoreAboutMeContextProvider.Provider value={contextValue}>{children}</MoreAboutMeContextProvider.Provider>
}

export default Provider
